import {combineReducers} from 'redux';
import actions from './search.actions';
import {handleActions} from 'redux-actions';

const initState = {
	query: '',
	hiddenQuery: '',
	filters: {
		communities: [],
		suburb: null
	},
	results: [],
	isRetrieving: false,
	searchFor: 'provider',
	recommendations: {}
};

const reducer = handleActions(
	{
		[actions.searchSetQuery]: (state, {payload}) => ({
			...state,
			query: payload || ''
		}),
		[actions.hiddenSearchSetQuery]: (state, {payload}) => ({
			...state,
			hiddenQuery: payload || ''
		}),
		[actions.searchClearResults]: state => ({
			...state,
			filters: {
				communities: [],
				suburb: null
			}
		}),
		[actions.searchToggleCommunityFilter]: (state, {payload: {uuid, value}}) => ({
			...state,
			filters: {
				...state.filters,
				communities: value
					? state.filters.communities.concat(uuid)
					: state.filters.communities.filter(filteredUuid => filteredUuid !== uuid)
			}
		}),
		[actions.searchFilterSuburb]: (state, {payload}) => ({
			...state,
			filters: {
				...state.filters,
				suburb: payload
			}
		}),
		[actions.searchClearResults]: state => ({
			...state,
			results: []
		}),
		[actions.searchComplete]: (state, {payload}) => ({
			...state,
			results: [...state.results, ...payload],
			isRetrieving: false
		}),
		[actions.searchStart]: state => ({
			...state,
			isRetrieving: true
		}),
		[actions.searchFor]: (state, {payload}) => ({
			...state,
			searchFor: payload
		}),
		[actions.searchRecommendationsLoaded]: (state, {payload}) => ({
			...state,
			recommendations: {
				...state.recommendations,
				...payload
			}
		}),
		[actions.resetState]: state => ({
			...initState
		})
	},
	initState
);

export default reducer;



// WEBPACK FOOTER //
// ./src/search/search.reducer.js